export default "__VITE_ASSET__BPJ8zdtl__"